module.exports = "/static/assets/cfb9384b0c3ec1f02641f37b34764e84.png";